/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgPerformanceArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.425 4.35378L13.44 5.85378L21.2625 5.77503L11.7262 15.3113L8.36247 11.34L7.25997 11.2913L0.0637207 18.4613L1.12122 19.5263L7.74372 12.93L11.1075 16.9013L12.21 16.95L22.3237 6.83628L22.245 14.6588L23.745 14.6738L23.85 4.24878L13.425 4.35378Z"
}));

export default SvgPerformanceArrowUp;